import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, requiredRole, requiredPermission }) => {
    const { user, loading, hasRole, hasPermission } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: 'linear-gradient(135deg, #00aeef 0%, #344ea1 100%)'
            }}>
                <div style={{ color: 'white', fontSize: '1.5rem' }}>Loading...</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole && !hasRole(requiredRole)) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                padding: '2rem'
            }}>
                <h1>Access Denied</h1>
                <p>You do not have permission to access this page.</p>
                <p>Required role: {Array.isArray(requiredRole) ? requiredRole.join(', ') : requiredRole}</p>
                <p>Your role: {user.role}</p>
            </div>
        );
    }

    if (requiredPermission && !hasPermission(requiredPermission)) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                padding: '2rem'
            }}>
                <h1>Access Denied</h1>
                <p>You do not have the required permission.</p>
                <p>Required permission: {requiredPermission}</p>
            </div>
        );
    }

    return children;
};

export default PrivateRoute;
